import { createSlice } from "@reduxjs/toolkit";
import TransactionMonitorService from "../../../app/data/transaction-monitor/transactionMonitorService";
import { IState } from "../..";
import { AppThunk } from "../../../app/store";
import { initialTransactionMessageReprocessState } from "./TransactionMessagesState";
import { TransactionMessageReprocessRequest } from "../../../app/data/transaction-monitor/models";

const transactionMonitorService = TransactionMonitorService.getInstance();

export const transactionMessageReprocessSlice = createSlice({
  name: "transactionMessageReprocess",
  initialState: initialTransactionMessageReprocessState,
  reducers: {
    resetTransactionDefinitions: (state) => initialTransactionMessageReprocessState,
    transactionMessageReprocessLoadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
    },
    transactionMessageReprocessLoadingSucceed: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
    },
    transactionMessageReprocessLoadingFailed: (state) => {
      state.loading = false;
      state.loadingFailed = true;
    },
  },
});

export const {
  resetTransactionDefinitions,
  transactionMessageReprocessLoadingStarted,
  transactionMessageReprocessLoadingSucceed,
  transactionMessageReprocessLoadingFailed,
} = transactionMessageReprocessSlice.actions;

export const transactionMessageReprocessSelector = (state: IState) => state.transactionMessageReprocess;

export const submitMessageForReprocessing = (
  requestData: TransactionMessageReprocessRequest,
  onSuccess?: () => void,
  onError?: (error: string) => void,
  onClose?: () => void
): AppThunk => async (dispatch) => {
  dispatch(transactionMessageReprocessLoadingStarted());

  const response = await transactionMonitorService.submitMessageForReprocessing(requestData);

  if (response.ok()) {
    dispatch(transactionMessageReprocessLoadingSucceed(response.data));
    onSuccess && onSuccess();
    onClose && onClose();
  } else {
    let error = "Internal Server Error, re-try the action or contact support";
    if (response && response.data && response.data.message) error = JSON.stringify(response.data.message);
    dispatch(transactionMessageReprocessLoadingFailed());
    onError && onError(error);
    onClose && onClose();
  }
};

const transactionMessageReprocessReducer = transactionMessageReprocessSlice.reducer;
export default transactionMessageReprocessReducer;
